import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";


function ProjectTemplateMileStonesForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectMileStoneTemplates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-template-milestone/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_template_id: data.organization_project_template_id || "",
          milestone_title: data.milestone_title || "",
          milestone_description: data.milestone_description || "",
          milestone_order: data.milestone_order || "",
          expected_completion_days: data.expected_completion_days || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project template data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectMileStoneTemplates();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_template_id: "",
    milestone_title: "",
    milestone_description: "",
    milestone_order: "",
    expected_completion_days: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.organization_project_template_id) errors.organization_project_template_id = "Project Template is required";
    if (!formData.milestone_title) errors.milestone_title = "Project Template Name is required";
    if (formData.milestone_title.length > 100) errors.milestone_title = "Max 100 characters allowed";
    if (formData.milestone_description && formData.milestone_description.length > 255)
      errors.milestone_description = "Max 255 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-template-milestone/${id}`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Template MileStone updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-template-milestone`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Template MileStone added");
      }

      navigate("/project-templates-milestone");
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  const [selectOptions, setSelectOptions] = useState({
    ProjectTemplates: []
  })

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  const fetchProjectTemplates = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-templates`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response ProjectTemplates is : ", response);

      setSelectOptions((prev) => ({ ...prev, ProjectTemplates: response.data.data }));
    } catch (e) {
      console.error("Failed to load ProjectTemplates");
    }
  };

  useEffect(() => {
    fetchProjectTemplates();
  }, [org?.organization_id]);


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Template MileStone"}
        addMessage={"Project Template MileStone"}
        homeLink={"/project-templates-milestone"}
        homeText={"Project Template MileStone"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

              

<Autocomplete
  fullWidth
  options={selectOptions?.ProjectTemplates || []}
  getOptionLabel={(option) => option.template_name || ""}
  value={
    selectOptions?.ProjectTemplates?.find(
      (pt) =>
        pt.organization_project_template_id ===
        formData.organization_project_template_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_template_id:
        newValue?.organization_project_template_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Template *"
      error={!!formErrors.organization_project_template_id}
      helperText={formErrors.organization_project_template_id}
    />
  )}
/>


            

                <TextField
                  fullWidth
                  name="milestone_title"
                  label="MileStone Title *"
                  value={formData.milestone_title}
                  onChange={handleChange}
                  error={!!formErrors.milestone_title}
                  helperText={formErrors.milestone_title}
                />


                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="MileStone Description "
                  name="milestone_description"
                  value={formData.milestone_description}
                  onChange={handleChange}
                  error={!!formErrors.milestone_description}
                  helperText={formErrors.milestone_description}
                />

                <TextField
                  fullWidth
                  type="number"
                  name="milestone_order"
                  label="MileStone Order "
                  value={formData.milestone_order}
                  onChange={handleChange}
                  error={!!formErrors.milestone_order}
                  helperText={formErrors.milestone_order}
                />

                <TextField
                  fullWidth
                  type="number"
                  name="expected_completion_days"
                  label="Expected Completion Days "
                  value={formData.expected_completion_days}
                  onChange={handleChange}
                  error={!!formErrors.expected_completion_days}
                  helperText={formErrors.expected_completion_days}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTemplateMileStonesForm